import React, { useCallback, useEffect, useMemo, useState } from 'react';
// utils
import { POSITIONS_COLOR } from '../../utils/constants';
import Search from '../Search/Search';
import { useDispatch, useSelector } from 'react-redux';
import {
	addPlayerToTeam,
	delFanaticPosition,
	delPauseId,
	delTeamsRound,
	fanaticModeBefore,
	fanaticPlayer,
	selectDraftConfig,
	setCountRender,
	setDraftPlayersAction,
	setStatus,
	setTradeValue,
} from '../../app/features/draftConfig/draftConfigSlice';
import { selectGroup } from '../../app/features/group/groupSlice';
import infoImg from '../../assets/img/Info.png';
import pauseImg from '../../assets/img/pause.png';

import {
	DraftPlayerItem,
	DraftPlayerItems,
	DraftPlayerWrapper,
	NumItem,
	NumWrapper,
	PicksInfo,
	SelectTeam,
	TeamPickIndex,
	Wrapper,
} from './DraftPlayerChoose.styles';
import { Switch } from '@mui/material';
import { ErrorBoundary } from 'react-error-boundary';
import {
	delPlayersDraft,
	playerPositionMulti,
	setCurrentPage,
	setPlayerManualChoose,
	setPositionPlayersDraft,
	setSearchPlayers,
	updateTeamADP,
	recordDraftPick,
} from '../../app/features/playersDraft/playersDraftSlice';
import {
	manualTradeAction,
	selectTrades,
	setAcceptTrade,
	setChangeTrades,
	setRandomFlag,
	setResetSelectTeam,
} from '../../app/features/trades/tradesSlice';
import { calculateADP, isOffUserBoard } from '../../utils/utils';
import ErrorFallBack from '../ErrorFallBack/ErrorFallBack';
import Pagination from '../Pagination/Pagination';
import SimulatorToSimulator from '../SimulatorToSimulator/SimulatorToSimulator';
import Spinner from '../Spinner/Spinner';


const PageSize = 10;
const DraftPlayerChoose = ({ playersDraft, draftStatus, setThisId , draftPlayers}) => {
	const groups = useSelector(selectGroup);
	const [colorShow, setColorShow] = useState(true);
	const {
		tradeValue,
		countRender,
		status,
		teamPickIndex,
		fanaticIndexPosition,
		fanaticChallenge,
		fanaticMode,
		tradingSimulatorAction,
		round,
		teams,
		fanaticModeValue,
		fanaticPlayerBefore,
		teamSelect
	} = useSelector(selectDraftConfig);


	const { randomAccepted, tradeRandomId } = useSelector(selectTrades);

	const dispatch = useDispatch();
	const draftBtnDisable = draftStatus === 'red' ? true : false;
	const [searchValue, setSearchValue] = useState('');

	const searchPosition = useCallback((positions = [], playersData = []) => {
		if (positions.includes('All')) {
			return playersData;
		}
		if (positions.length) {
			return playersData.filter(player => {
				const position = player.position;
				return positions.includes(position);
			});
		}
	}, []);

	const currentTableData = useMemo(() => {
		const firstPageIndex = (playersDraft.currentPage - 1) * PageSize;
		const lastPageIndex = firstPageIndex + PageSize;
		let playersData = playersDraft.results;
		const playerSearchPosition = searchPosition(playersDraft.position, playersData);
		playersData = playerSearchPosition.filter(player => {
			const name = player.player.toLowerCase();
			return name.includes(playersDraft.search.toLowerCase());
		});

		const playersDataSlice = playersData.slice(firstPageIndex, lastPageIndex);
		return { playersData, playersDataSlice };
	}, [playersDraft.currentPage, playersDraft.search, playersDraft.position, playersDraft.results]);

	useEffect(() => {
		const timer = setTimeout(() => {
			dispatch(setSearchPlayers(searchValue));
		}, 500);
		return () => {
			clearTimeout(timer);
		};
	}, [setSearchValue, searchValue]);

	const playerConcat = (playerItem, teamId, upPlayers = {}, idx) => {
		const teamItem = structuredClone(tradeValue.results[teamId - 1]);
		const pickTeam = teamItem['pick'];
		teamItem['player'] = playerItem;
		teamItem['playerDepth'] = idx + 1;
		const newTradeValue = tradeValue.results.map(item => {
			if (item.index === teamItem.index && item?.index_position === teamItem?.index_position) {
				return teamItem;
			}
			return item;
		});
		if (fanaticChallenge.length) {
			// debugger;
			if (fanaticChallenge[0].mode === +teamItem.round_index_number) {
				let pickBefore = 1;
				if (fanaticChallenge[0].mode === 1) {
					pickBefore = 5 - +teamItem.iteration;
					if (teamItem['pick'] === 1) {
						pickBefore = undefined;
					} else if (teamItem['pick'] === 2) {
						pickBefore = undefined;
					} else if (teamItem['pick'] === 3) {
						pickBefore = 2 - +teamItem.iteration <= 0 ? 3 : 2 - +teamItem.iteration;
					} else if (teamItem['pick'] === 4) {
						pickBefore = 3 - +teamItem.iteration <= 0 ? 4 : 3 - +teamItem.iteration;
					} else if (teamItem['pick'] === 5) {
						pickBefore = 4 - +teamItem.iteration <= 0 ? 5 : 4 - +teamItem.iteration;
					}
				}
				if (fanaticChallenge[0].mode === 2) {
					pickBefore = 10 - +teamItem.iteration;
					let qwe =
						pickTeam - pickBefore <= 0 ? teams.length + pickTeam - pickBefore : teams.length + pickTeam + pickBefore;
					// debugger;
				}
				if (fanaticChallenge[0].mode === 3) {
					pickBefore = 15 - +teamItem.iteration;
				}
				dispatch(
					fanaticPlayer({
						pick: teamItem['index'] - pickBefore,
						player: playerItem,
						playerDepth: idx + 3,
						round: +teamItem.round_index_number,
					})
				);
			}
		}
		if (fanaticMode) {
			let findNextItem=tradeValue.results.filter(item=>item.round.name===teamSelect[0].name);
			let indicesToCalculate=  new Set();
			let indicesToNotCalculate=  new Set();
			for (let i = 1; i < findNextItem.length; i++) {
				if (findNextItem[i].index - findNextItem[i - 1].index < fanaticModeValue && findNextItem[i].index - findNextItem[i - 1].index >0) {
					indicesToCalculate.add(findNextItem[i-1].index);
					indicesToNotCalculate.add(findNextItem[i].index)
				}
			}
			let uniqueIndicesToCalculate = Array.from(indicesToCalculate);
			let uniqueIndicesToNotCalculate = Array.from(indicesToNotCalculate);
			if(indicesToCalculate.length !==0 && uniqueIndicesToCalculate?.includes(teamItem['index'])){
				let pickBefore= 2*(fanaticModeValue - (+teamItem.iteration))
				dispatch(
					fanaticModeBefore({
						player: {
							pick: teamItem['index'] - pickBefore,
							player: playerItem,
							playerDepth: idx + 1,
							round: +teamItem.round_index_number,
						},
						action: 'inc',
					})
				);
			}
			else if(indicesToCalculate.length !==0 && uniqueIndicesToNotCalculate.includes(teamItem['index'])){
				let pickBefore= 2*(fanaticModeValue - (+teamItem.iteration))
				dispatch(
					fanaticModeBefore({
						player: {
							pick: uniqueIndicesToCalculate[0] - pickBefore + 1,
							player: playerItem,
							playerDepth: idx + 1,
							round: +teamItem.round_index_number,
						},
						action: 'inc',
					})
				);
				console.log("bad case")
			}
			else{
				let pickBefore= fanaticModeValue - +teamItem.iteration;
				console.log(pickBefore, "pickBefore")
				dispatch(
					fanaticModeBefore({
						player: {
							pick: teamItem['index'] - pickBefore,
							player: playerItem,
							playerDepth: idx + 1,
							round: +teamItem.round_index_number,
						},
						action: 'inc',
					})
				);
			}
		}
		const playerItemPos = {
			...playerItem,
			roundTeam: +teamItem.round_index_number,
		};
		dispatch(delPlayersDraft([playerItemPos]));
		dispatch(setTradeValue({ ...tradeValue, results: newTradeValue }));
		dispatch(setDraftPlayersAction({ ...teamItem, upPlayers }));
		if (fanaticChallenge.length !== 0) {
			// Recorded for every round — the "same player at most twice" cap covers round 2 too.
			dispatch(
				addPlayerToTeam({
					teamId: teamItem.round.id,
					playerData: { name: playerItem.player, id: playerItem.id },
					infoDraft: { round: +teamItem.round_index_number, iteration: teamItem.iteration, pick: teamItem.pick },
				})
			);
			// The old wipe of choosePlayers / infoDraft at the end of iterations 5 and 10 is gone —
			// the 2-per-5-iterations reset is handled by the block count in filterPlayers, and wiping
			// the record here would also clear the user team's "never re-pick a player" history.
		}
	};


	const playerChoose = (item, bpa) => {
		let team = teamPickIndex[0] ?? fanaticIndexPosition[0];
		const teamItem = structuredClone(tradeValue.results[team - 1]);
		let teamName = tradeValue.results[team - 1].round.name;
		teamName = teamName === '49ers' ? 'ers' : teamName;

		// Selection number is the team's draft slot, held CONSTANT across the 5 iterations
		// (client confirmed: no iteration reduction, the 1/8 factor is out).
		const selection = teamItem.index;

		// A player is unavailable to THIS pick — and so must not be shifted by the move-down — if
		// he was drafted this iteration (once-per-iteration, any team) OR drafted by THIS team in
		// any earlier iteration (a player can't be re-picked, so he's off our board for the rest
		// of the challenge).
		const teamADPMap = playersDraft.teamADP?.[teamName] ?? {};
		const userTeamName = teamItem.round.name;
		const unavailableIds = new Set(
			(draftPlayers ?? [])
				.filter(p => isOffUserBoard(p, {
					iteration: teamItem.iteration,
					teamName: userTeamName,
					mode: fanaticChallenge?.[0]?.mode,
				}))
				.map(p => p.player.id)
		);
		const adpBoardIds = playersDraft.teamBoards?.[teamName] ?? [];
		const teamBoardRankForADP = new Map(adpBoardIds.map((id, idx) => [id, idx + 1]));
		const baseAdp = (p) => teamADPMap[p.id] ?? teamBoardRankForADP.get(p.id) ?? p.ranking ?? 0;
		const allByIdADP = new Map((playersDraft.allPlayers ?? []).map(p => [p.id, p]));
		const availableBoardADP = (adpBoardIds.length
			? adpBoardIds.map(id => allByIdADP.get(id)).filter(Boolean)
			: playersDraft.results
		).filter(p => !unavailableIds.has(p.id));
		const boardWithADP = availableBoardADP.map(p => ({ ...p, adp: baseAdp(p) }));
		const pickedWithADP = { ...item, adp: baseAdp(item) };

		// Record the pick with the backend as it happens — the server owns the ADP math and
		// applies it atomically, so concurrent drafts on this team accumulate rather than
		// overwriting. Send no ADP values; drafted_player_ids excludes this pick.
		dispatch(recordDraftPick({
			teamName: tradeValue.results[team - 1].round.name,
			playerId: item.id,
			selection,
			draftedPlayerIds: [...unavailableIds].filter(id => id !== item.id),
		}));

		const adpMap = calculateADP(selection, boardWithADP, pickedWithADP);
		// [ADP] running-average trace — picked before→after (or "value, no move"), plus every
		// skipped player pulled toward the selection number. Watch the flip and the collapse here.
		{
			const r2 = (n) => Math.round(n * 100) / 100;
			const beforeADP = new Map(boardWithADP.map(p => [p.id, p.adp]));
			const pickedAfter = adpMap[item.id];
			const skipped = Object.entries(adpMap)
				.filter(([id]) => +id !== item.id)
				.sort((a, b) => beforeADP.get(+a[0]) - beforeADP.get(+b[0]))
				.slice(0, 8)
				.map(([id, after]) => `${allByIdADP.get(+id)?.player ?? id} ${r2(beforeADP.get(+id))}→${r2(after)}`);
			console.log(
				`[ADP] sel ${selection} it${teamItem.iteration} ${teamName} picked ${item.player} ` +
				`${r2(pickedWithADP.adp)}${pickedAfter != null ? '→' + r2(pickedAfter) : ' (value, no move)'}` +
				(skipped.length ? ` | skipped↓: ${skipped.join(', ')}` : '')
			);
		}
		if (Object.keys(adpMap).length) {
			dispatch(updateTeamADP({ teamName, adpMap }));
		}

		const playerItemPos = { ...item, roundTeam: +teamItem.round_index_number };
		dispatch(setCurrentPage(1));
		dispatch(setPositionPlayersDraft(['All']));
		playerConcat(item, team, adpMap, bpa);
		dispatch(setPlayerManualChoose(playerItemPos));
		dispatch(delTeamsRound(teamPickIndex[0]));
		dispatch(delFanaticPosition(fanaticIndexPosition[0]));
		setThisId(teamPickIndex[0]);
		dispatch(setCountRender());
	};

	const tradeAction = useCallback(() => {
		dispatch(setChangeTrades(false));
		dispatch(manualTradeAction({ countRender, manualTrade: true }));
		dispatch(setResetSelectTeam());
		dispatch(setAcceptTrade(false));
	}, [countRender]);

	useEffect(() => {
		if (randomAccepted && tradeRandomId.length > 0 && tradeRandomId.includes(countRender + 1)) {
			tradeAction();
			dispatch(setRandomFlag(true));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [randomAccepted, tradeRandomId, countRender]);

	return (
		<>
			{playersDraft.loading ? (
				<Spinner />
			) : (
				<ErrorBoundary FallbackComponent={ErrorFallBack}>
					<Wrapper>
						<SelectTeam>
							<div className="team">
								{tradeValue?.results && (
									<>
										<img
											src={
												status === 'red'
													? tradeValue?.results[countRender - 1].round?.logo
													: tradeValue?.results[countRender].round?.logo
											}
											alt={
												status === 'red'
													? tradeValue?.results[countRender - 1].round.name
													: tradeValue?.results[countRender].round.name
											}
											width={60}
										/>
										<h2>
											{status === 'red'
												? tradeValue?.results[countRender - 1].round.name
												: tradeValue?.results[countRender].round.name}
										</h2>
									</>
								)}
							</div>
							{fanaticChallenge.length === 0 ? (
								<PicksInfo>
									<p>Remaining picks</p>
									<TeamPickIndex>
										{teamPickIndex.map((item, idx) => {
											return (
												<span key={idx}>
													{item}
													{idx === teamPickIndex.length - 1 ? null : ','}
												</span>
											);
										})}
									</TeamPickIndex>
								</PicksInfo>
							) : null}
						</SelectTeam>
						<Search
							value={searchValue}
							handleChange={e => {
								setSearchValue(e.target.value);
							}}
						/>
						<NumWrapper>
							{groups?.positions &&
							groups?.positions
								.filter((item) => {
									if ([1, 2, 3].includes(round)) {
										const position = item?.split(' ')[0]; //check
										return position !== "P" && position !== "K"; // Remove "P" and "K"
									}
									return true;
								})
								.map((item, idx) => {
								const id = idx + 1;
									const position = item?.split(' ')[0];
								return (
									<NumItem
										key={id}
										backColor={POSITIONS_COLOR[position]}
										onClick={() => {
											dispatch(setCurrentPage(1));
											dispatch(playerPositionMulti(position));
										}}
										className={playersDraft.position.includes(position) ? 'active' : null}
									>
										<span>{position}</span>
									</NumItem>
								);
							})}
							<div>
								Show positions colors in list
								<Switch defaultChecked onChange={() => setColorShow(prev => !prev)} />
							</div>
							{fanaticChallenge.length === 0 && !fanaticMode && !tradingSimulatorAction ? (
								<div className="trades-btn">
									<button onClick={tradeAction}>Trades</button>
								</div>
							) : null}
						</NumWrapper>
						<DraftPlayerWrapper>
							<DraftPlayerItems>
								<>
									{playersDraft.results.length > 0 &&
										currentTableData.playersDataSlice.map((item, idx) => {
											return (
												<DraftPlayerItem key={idx} backColor={colorShow ? POSITIONS_COLOR[item.position] : ''}>
													<div className="player-draft">
														<div className="player-td player-rank">
															<p>Rank</p>
															<span>{item?.ranking}</span>
														</div>
														<div className="player-td player-rank">
															<p>BPA</p>
															<span>{item?.bpa}</span>
														</div>
														<div className="player-td player-rank">
															<p>ADP</p>
															<span>{item?.adp}</span>
														</div>
														<div className="player-td player-adp">
															<p>School</p>
															{item?.school_ref?.logo ? (
																<img src={item?.school_ref?.logo} alt={item.school} />
															) : (
																<span>{item.school}</span>
															)}
														</div>
														<h4 className="player-td player-name">{item.player}</h4>
														<h4 className="player-td player-position">{item.position}</h4>
														<h4 className="player-td player-college">{item.school}</h4>
														<img src={infoImg} alt="info" />
														<button
															className="player-td player-draft-btn"
															disabled={draftBtnDisable}
															onClick={() => playerChoose(item, item?.bpa)}
														>
															Draft
														</button>
													</div>
												</DraftPlayerItem>
											);
										})}
								</>
							</DraftPlayerItems>
							{draftBtnDisable && (
								<div className="player-draft-btn-wrap">
									<button
										className="player-draft-btn"
										onClick={() => {
											dispatch(setStatus('green'));
											dispatch(delPauseId());
										}}
									>
										<img src={pauseImg} alt="play_pause" />
										<span>Start Draft</span>
									</button>
								</div>
							)}
							<Pagination
								totalCount={currentTableData.playersData.length}
								pageSize={PageSize}
								currentPage={playersDraft.currentPage}
								previous={playersDraft.previous}
								next={playersDraft.next}
								onPageChange={page => {
									dispatch(setCurrentPage(page));
								}}
							/>
						</DraftPlayerWrapper>
					</Wrapper>
					{tradingSimulatorAction ? <SimulatorToSimulator /> : null}
				</ErrorBoundary>
			)}
		</>
	);
};

export default DraftPlayerChoose;
